package com.anjuros.website.templates.template6.modules

import com.anjuros.website.templates.template6.util.ResKey

enum class Template6Info (
        val title: ResKey,
        val description: ResKey
    )
{
    Template6Info1(
        ResKey.TEMPLATE6_INFO_TITLE1,
        ResKey.TEMPLATE6_INFO_DESC1
    ),

    Template6Info2(
    ResKey.TEMPLATE6_INFO_TITLE2,
    ResKey.TEMPLATE6_INFO_DESC2
    ),

    Template6Info3(
    ResKey.TEMPLATE6_INFO_TITLE3,
    ResKey.TEMPLATE6_INFO_DESC3
    ),

    Template6Info4(
    ResKey.TEMPLATE6_INFO_TITLE4,
    ResKey.TEMPLATE6_INFO_DESC4
    )
}